import { render } from "./SourcePicker.vue?vue&type=template&id=0c0ea4b2&scoped=true"
import script from "./SourcePicker.vue?vue&type=script&lang=js"
export * from "./SourcePicker.vue?vue&type=script&lang=js"

import "./SourcePicker.vue?vue&type=style&index=0&id=0c0ea4b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c0ea4b2"]])

export default __exports__